<sh-access-bar class="display-contents" label="Virtual Assets Library" slot="access" condensed>
  <sh-icon button icon="help" id="helpMenu" slot="functions"></sh-icon>
  <sh-icon class="update-theme-icon" button icon="circle-half" slot="functions" (click)="updateThemeSetting()">
  </sh-icon>
  <sh-user-identifier (click)="temp.click()" slot='user' name="{{name}}" [image]="'url(' + (userProfileImageURL) + ')'"
    info='Siemens Healthineers' id="user_dropdown">
  </sh-user-identifier>
  </sh-access-bar>
<sh-text class="description"> This is a service offered by SLM and EDU to Siemens Healthineers. It is not a public offering
  and for internal use only. This is supported only in Chrome Browser.
</sh-text>
<sh-tabs class="tabs" slot="tabs">
  <sh-tab-item label="Home" routerLink="" id="home" [active]=config.homeActive class="child-tab"></sh-tab-item>
  <sh-tab-item label="Asset Category" id="search-the-lib" (click)="search()" (mouseenter)="getAssetCategory()"
    (mouseleave)="showFolderCategory()" [active]=config.searchActive class="child-tab">
  </sh-tab-item>
  <sh-tab-item label="Personal Browser" id="personal-browser" (click)="personalBrowser()"
    [active]=config.personalBrowserActive class="child-tab"></sh-tab-item>

  <sh-tab-item label="Upload Assets" id="upload-assets" routerLink="upload-new-asset/1" [disabled]=!hasUploadAccess
    [active]=config.uploadAssetsActive class="child-tab"></sh-tab-item>

  <sh-tab-item label="Profile" #temp class="child-tab display-none"></sh-tab-item>
  <span class="search-box-span">
    <sh-input-text label='Search' id="searchText" [(value)]="searchKey" (keyup)="searchAssets($event)"></sh-input-text>
  </span>

  <sh-notifications class="notification-card">
    <sh-notification-item [visible]="isShowNotificationError" type="error" label="Error">
      {{showErrorMessage}}
    </sh-notification-item>

    <sh-notification-item [visible]="isShowNotificationSuccess" type="confirm" label="Success">
      {{showSuccessMessage}}
    </sh-notification-item>
  </sh-notifications>

</sh-tabs>

<app-wizard></app-wizard>

<div class="resize">
  <sh-popover target="user_dropdown" position="bottom" class="user-dropdown">
    <sh-menu-item (click)='changeActive($event)'
      label="{{'Last Login '+(loggedInUser.lastLoginDate | dateToInterval)}}"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="{{'User Permissions : '+loggedInUser.userGroup}}">
    </sh-menu-item>
    <sh-divider></sh-divider>
    <sh-menu-item (click)='changeActive($event)' label="My Profile" id="userName"
      [routerLink]="['userProfile',userEmailId]"></sh-menu-item>
    <sh-menu-item label="Configuration" id="configuration">
      <sh-icon button icon="right-s" size="s" slot="configuration"></sh-icon>
    </sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="Feedback" id="feedback" (click)="openFeedbackModal()">
    </sh-menu-item>
    <sh-menu-item label="Sign Out" (click)="logout()" id="user_logout"></sh-menu-item>
  </sh-popover>
  <sh-popover (click)='changeActive($event)' class="popout manage" id="config" sub-menu target="configuration"
    position="left">
    <sh-menu-item label="Settings" (click)="temp.click();changeActive($event);" [routerLink]="['settings', userId]"
      id="user_settings"></sh-menu-item>
    <!-- <sh-menu-item (click)='changeActive($event)' label="Manage VAL Users" [routerLink]="['admin', userId]" *ngIf="manageUserFlag" id="manage_users"></sh-menu-item> -->
    <sh-menu-item (click)='changeActive($event)' label="Manage Users" [routerLink]="['userGroup/L1/manageuser']"
      *ngIf="manageUserFlag || requestAccessFlag" id="manageUser"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="Manage Groups" [routerLink]="['userGroup/L1/managegroup']"
      *ngIf="manageUserFlag || requestAccessFlag" id="manageGroup"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="Dashboard" [routerLink]="['user/admin/dashboard']"
      *ngIf="manageUserFlag || requestAccessFlag" id="dashboard"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="Administration Page" *ngIf="manageUserFlag"
      onclick="document.querySelector('#activeUsersModal').visible = true" (click)="showAdministrationPageModal()"
      id="administartion"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="Request Access Token" [routerLink]="['userGroup/L1']"
      *ngIf="requestAccessFlag" id="request_access_item"></sh-menu-item>
  </sh-popover>
  <sh-popover class="help-menu" target="helpMenu" position="bottom">
    <sh-menu-item (click)='changeActive($event)' label="API Documentation" [routerLink]="['documentation']"
      *ngIf="requestAccessFlag || devUser" id="apidocumentation"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event);openProductInformationModal()' label="Product Information"
      *ngIf="filePrsent"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="User Manual" id="help" (click)="downloadHelp()"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="FAQ" id="faq" [routerLink]="['faq']"></sh-menu-item>
    <sh-menu-item (click)='changeActive($event)' label="Terms and Conditions" id="termsAndConditions"
      (click)="showTermsAndConditions()"></sh-menu-item>
  </sh-popover>
</div>

<router-outlet class="width-0"></router-outlet>

<sh-modal id="configModal" label='Application Details' modal-height='500px' modal-width='900px' hidden>
  <sh-divider></sh-divider>
  <br>
  <sh-grid fit-content="true">
    <div columns="5" col-m="5" col-s="12">
      <sh-text class="config-modal-font">Product Name : <b>{{ prodConfig?.ProductName }}</b></sh-text>
      <sh-divider></sh-divider>
      <sh-text class="config-modal-font">Major Version : <b>{{ prodConfig?.MajorVersion }}</b></sh-text>
      <sh-divider></sh-divider>
      <sh-text class="config-modal-font">Build Number : <b>{{ prodConfig?.BuildNumber }}</b></sh-text>
      <sh-divider></sh-divider>
    </div>
    <div columns="7" col-m="7" col-s="12">
      <sh-text class="config-modal-font">Disclaimer: <br> <br>
        This is a service offered by SLM and EDU to Siemens Healthineers.
        It is not a public offering and for internal use only.
      </sh-text>
      <br>
      <sh-text class="config-modal-font">Browser Support : <b>The product is supported only in Chrome</b></sh-text>
      <br>
      <sh-text class="config-modal-font">
        <a target="_blank" class="license-info" href="assets\LicenseInfo\LicenseInfo-Virtual Assets Library.html">
          <sh-text>License Info</sh-text>
        </a>
      </sh-text>
    </div>
  </sh-grid>
  <div class="whats-new-div">
    <sh-text class="whats-new-heading" *ngFor="let version of featuresInVersion;">
      What's new in - {{ version.VersionNumber}} <br> <br>
      <span *ngFor="let feature of version.Features;" class="feature">
        &nbsp;&nbsp;&nbsp;&nbsp;{{feature}}<br>
      </span>
      <br />
    </sh-text>
  </div>

  <sh-button color='tertiary' slot='footer' label='Close'
    onclick="document.getElementById('configModal').removeAttribute('visible')">
  </sh-button>
</sh-modal>

<sh-modal id="feedbackModal" label="Feedback" modal-width="480px" modal-height="480px">
  <div class="feedback-modal-div">
    <p>Please provide your valuable feedback{{assetDetails}}:</p>
    <div class="star-rating-grid">
      <sh-icon slot="functions" button icon="favorite" (mouseenter)="rating=1"
        [ngClass]="{'rating-color': rating >= 1 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" (mouseenter)="rating=2"
        [ngClass]="{'rating-color': rating >= 2 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" (mouseenter)="rating=3"
        [ngClass]="{'rating-color': rating >= 3 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" (mouseenter)="rating=4"
        [ngClass]="{'rating-color': rating >= 4 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" (mouseenter)="rating=5"
        [ngClass]="{'rating-color': rating >= 5 }"></sh-icon>
    </div>
  </div>
  <div [ngSwitch]="rating" class="feedback-modal-div">
    <span *ngSwitchCase="1">Very bad!</span>
    <span *ngSwitchCase="2">Bad!</span>
    <span *ngSwitchCase="3">Average!</span>
    <span *ngSwitchCase="4">Good!</span>
    <span *ngSwitchCase="5">Very Good!</span>
    <span *ngSwitchDefault>&nbsp;</span>
  </div>
  <div>
    <p class="feedback-p">Please leave your comments, feedback, concerns or suggestions:</p>
    <br />
    <sh-input-text label='Feedback' textarea="true" id="fbComments" [(value)]="feedbackComments"
      (value-changed)="feedbackComments=$event.target.value"></sh-input-text>
    <sh-tooltip *ngIf="feedbackCommentsError" label="Please enter your Comments" target="fbComments"
      placement="bottom-right" variation="short"></sh-tooltip>
    <br />
    <div class="submitted-by">Submitted by: {{loggedInUser?.name}}</div>
  </div>
  <sh-button color='tertiary' slot='footer' label='Cancel'
    onclick="document.getElementById('feedbackModal').removeAttribute('visible')"></sh-button>
  <sh-button color='secondary' slot='footer' label='Submit' (click)="submitFeedback()"
    [disabled]="rating == 0 && !feedbackComments && feedbackComments.trim() === ''"></sh-button>
</sh-modal>

<sh-modal id="activeUsersModal" label='Administration Page' modal-height='auto' sticky modal-width='70vw'>
  <app-administration-page #administrationpage *ngIf="showAdministrationPage"></app-administration-page>
  <sh-button color='secondary' slot='footer' label='Email Statistics' shape="pill-m" *ngIf="config.userActivity"
    (click)="emailStatistics()">
  </sh-button>
  <sh-button color='tertiary' slot='footer' label='Close'
    onclick="document.querySelector('#activeUsersModal').visible = false" (click)="closeAdministrationPageModal()">
  </sh-button>
</sh-modal>

<sh-modal id="termsModalView" label='Terms and Conditions' modal-height='500px' hidden modal-width='500px'>
  <terms-and-conditions [showAcceptDecline]="false"></terms-and-conditions>
</sh-modal>